import { appStore } from "./app";
import { geoStore } from "./geo";

export const STORES = {
  app: appStore,
  geo: geoStore,
};
